import { Injectable } from '@angular/core';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { Observable } from 'rxjs';
import { AplicacionModel } from '../Modelo/Aplicacion.model';

@Injectable({
    providedIn: 'root'
})
export class AplicacionesService {

    constructor(
        private Utilidades: UtilidadesService
    ) { }

    public Lista(): Observable<AplicacionModel[]> {
        return this.Utilidades.Get("Aplicaciones");
    }
}